module.exports = __webpack_public_path__ + "img/similar-pidgotovka-do-vac.02d9c6ad.png";